export default __webpack_public_path__ + "static/media/Map.4aadee55.svg";